import { LogMessage } from "./types";

export type FormattedLogMessage = LogMessage & {
	highlightFlag: any[];
	parsedLogArgs: any[];
	allLogArgs: string;
	previousRowTimeDelta: number;
	timeElapsedFromStartup: number;
};

/**
 * Small object that creates the logMessage object that we use to display everything.
 */
export const formatLogMessage = (message: LogMessage): FormattedLogMessage => {
	let newMessage: FormattedLogMessage = {
		...message,
		highlightFlag: [],
		parsedLogArgs: [],
		allLogArgs: "",
		previousRowTimeDelta: 0,
		timeElapsedFromStartup: 0,
	};

	let logArgs: string[] = [];
	let parsedLogData;
	try {
		parsedLogData = JSON.parse(message.logData);
	} catch (err) {
		parsedLogData = {
			Note: "*** LoggingService: error parsing data (see local console warning for data) ***",
		};
		console.warn(parsedLogData, message.logData, err);
	}
	// we stringify all the args below. no need for multiple copies of the same thing.
	for (const property in parsedLogData) {
		// don't know how many arguments passed in to console output`
		if (parsedLogData.hasOwnProperty(property)) {
			newMessage.parsedLogArgs.push(parsedLogData[property]);
			const argString = JSON.stringify(parsedLogData[property]);
			logArgs.push(argString);
		}
	}
	// Join all of the parsed args, replace any double quotes that we created with a space.
	newMessage.allLogArgs = logArgs.join(" ").replace("", " ").replace('" "', " ");
	delete newMessage.logData;
	return newMessage;
};
